import bottomCurve from "planets/roya/bottom-curve"
import trail from "planets/roya/trail"
import {
  PlanetHorizon,
  ShortPlanetHorizon,
  PlanetHorizonContainer,
  ShortPlanetHorizonContainer,
  PlanetHorizonTitle
} from "planets/roya/horizon"
import editProfileBackground from "planets/roya/roya-edit-profile.svg"

export default {
  mainColor: "#ffbdff",
  secondaryColor: "#fcffb2",
  bottomCurve: bottomCurve,
  trail: trail,
  knowledgeAreaSlide: { prev: "#6edbf0", next: "#6edbf0" },
  dailyMission: {
    questionSlider: { prev: "#6edbf0", next: "#6edbf0", arrowColor: "#fff" }
  },
  btnPrimary: { backgroundColor: "#ff9229", textColor: "#fff", shadowColor: "#ce6d10" },
  btnLink: { backgroundColor: "#6edbf0", activeTextColor: "#ffbdff" },
  gamificationBar: {
    white: { textColor: "#6edbf0" },
    colored: { textColor: "#fff" }
  },
  header: { colored: { backgroundColor: "#8e3fac" } },
  horizon: {
    PlanetHorizon,
    ShortPlanetHorizon,
    PlanetHorizonContainer,
    ShortPlanetHorizonContainer,
    PlanetHorizonTitle
  },
  editProfileBackground: editProfileBackground,
  games: {
    title: "#6edbf0",
    border: "#ffbdff",
    detailsHeader: "#ffbdff"
  }
}
